import React from 'react';

const DocumentItem = ({ document, onToggleDefault, onDisplay, onRemove }) => {
  const toggleDefault = () => onToggleDefault(document);
  const display = () => onDisplay(document);
  const remove = event => onRemove(event, document);

  return (
    <tr key={document.id}>
      <td onClick={display}>
        <button
          type="button"
          className="ui basic icon red button delete"
          onClick={remove}
        >
          <i className="remove icon" />
        </button>
      </td>
      <td onClick={display}>{document.label}</td>
      <td>
        <div className="ui slider checked checkbox">
          <input
            type="checkbox"
            onChange={toggleDefault}
            checked={document.by_default ? 'checked' : ''}
          />
          <label />
        </div>
      </td>
    </tr>
  );
};

export default DocumentItem;



// WEBPACK FOOTER //
// ./src/modules/saas/settings/components/DocumentItem.js